// Guaubuelo: arreglo para la barra fija de compra de Horizon (sticky-add-to-cart).
// Si el formulario tiene un campo obligatorio vacío (el nombre de la manta), la barra de
// Horizon no añade nada pero marca el botón como añadido. Aquí se valida antes: se lleva
// al cliente al campo y no se toca el botón.
window.addEventListener(
  'click',
  (evento) => {
    const boton = evento.target.closest?.('.sticky-add-to-cart__button');
    if (!boton) return;
    const form = document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
    if (!form || form.checkValidity()) return;
    evento.preventDefault();
    evento.stopImmediatePropagation();
    form.reportValidity();
  },
  { capture: true }
);
